export default {
  administration: {
    // companies
    companyAdd: 'Adding a new company',
    companyEdit: 'Editing company no. sys.',
    companyNew: 'New company',
    noCompanies: 'No companies in the system',
    basicData: 'Basic data',
    visualData: 'Visual data',
    sensitiveData: 'Sensitive data',
    sensitiveDataWarning:
      'Warning! Changing this data will immediately affect the operation of the system. Make modifications only when you are sure about their impact on the POK system.',
    logo: 'Logo',
    stamp: 'Stamp',
    personalLanguage: 'Naming',
    language: 'Language',
    color: 'Color',
    invoiceTemplate: 'Invoice template',
    noFull: 'Item number',
    emailInvoice: 'Invoice email',
    footer: 'Footer',
    footerEn: 'Footer in English',
    uploadGraphicFile: 'Upload graphic file',
    showMargin: 'Show margin',
    eod: 'Communicate with EOD',
    ksef: 'Supports KSeF',
    symphonyHandel: 'Exports FVS to Symphony Handel',

    // employees
    synchrWithOneTool: 'Synchronize with OneTool',
    all: 'All',
    inactive: 'Inactive with permissions',
    deletePermissions: 'Delete permissions',
    deleteUserPermissions: 'Delete user permissions',
    askDeleteUserPermissions:
      'Are you sure you want to delete all permissions assigned to this user?',
    askDeletePermissions:
      'Are you sure you want to delete all permissions for all inactive users?',
    position: 'Position',
    oneToolId: 'OneTool ID',
    nameSurname: 'Name and surname',
    login: 'Login',
    email: 'Email',
    supervisor: 'Supervisor',
    manager: 'Manager',
    technical: 'Technical',
    noEmployees: 'No employees in the system',
    signAdd: 'Adding a new signature to employee: {{employeeName}}',
    signEdit: 'Editing employee signature: {{employeeName}}',
    employeeSign: 'Signature',
    askDeleteSignEmployee: 'Are you sure you want to delete the signature?',

    // teams
    teamNew: 'New team',
    teamEdit: 'Editing team no. sys.',
    teamAdd: 'Adding a new team',
    managerName: 'Team manager',
    noTeams: 'No teams in the system',
    paeSupport: 'Supports PAE',
    tvSupport: 'Supports TV',
    oneToolTeam: 'OneTool Team',
    oneToolTeams: 'OneTool Teams',
    noOneToolTeams: 'No OneTool teams',
    pathPhase: 'Phase',
    pathPhaseTooltip:
      'The phase assigned to this team. A team with an assigned phase is a <strong>"phase team"</strong> - this lets the system automatically recognise which team handles a position in a given phase, without asking the user. Leave empty for teams outside the phase model.',
    pathPhaseCompanyTooltip:
      'Turns the phase mechanism on for this company. When <strong>on</strong>, campaigns created in this company can specify which phases apply, and positions and orders can be tagged with a phase. When <strong>off</strong>, this company has no phases at all and works exactly as today. The toggle itself does <strong>not</strong> make the phase mandatory.',

    // media plan profiles
    estimateProfiles: 'Mediaplan profiles',
    estimateProfileNew: 'New profile',
    estimateProfileAdd: 'Adding a new profile',
    estimateProfileEdit: 'Editing profile',
    noEstimateProfiles: 'No mediaplan profiles in the system',
    commissions: 'Commissions',
    technicalCost: 'Technical cost',
    relatedTeams: 'Related teams',
    tv: 'TV',
    tvBuying: 'TV buying',
    autoSalesBlockDisabled: 'Auto sales block disabled',
    absence: 'Absence',
    visible: 'Visible',
    obligatory: 'Mandatory',

    // profile categories
    profileCategory: 'Profile category',
    profileCategories: 'Profile categories',
    profileCategoryAdd: 'Adding a new profile category',
    profileCategoryNew: 'New profile category',
    profileCategoryEdit: 'Editing profile category',
    noProfileCategories: 'No profile categories in the system.',
    salesFinancialAccount: 'Sales financial account',
    purchasesFinancialAccount: 'Purchases financial account',
    commissionsFinancialAccount: 'Commissions financial account',
    profileCategoryAccountsInternal: 'Contractor internal to Group One',
    profileCategoryYearAdd: 'Adding new accounts to profile categoty',
    profileCategoryYearNew: 'New accounts for profile category',
    profileCategoryYearEdit: 'Editing accounts for profile category',
    profileCategoryYearDelete: 'Deleting accounts from profile category',
    askProfileCategoryYearDelete:
      'Are you sure you want to delete accounts from profile category',
    noProfileCategoryYears: 'No accounts for profile category.',
    profile: 'Profile',

    // profile fields
    sales: 'Sales',
    rcSalesTotal: 'RC Sales Total',
    salesSurchargePercent: 'Sales surcharge %',
    salesDiscountPercent: 'Sales discount %',
    salesNet: 'Sales Net',
    salesCommissionPercent: 'Sales commission %',
    salesCommissionAmount: 'Sales commission amount',
    salesNetTechnicalCost: 'Sales net technical cost',
    salesBeerTax: 'Sales beer tax',
    salesPrintingCosts: 'Sales printing costs',
    salesOperatingFee: 'Sales operating fee',
    salesBlockSurcharge: 'Sales block surcharge',
    salesTransferCosts: 'Sales transfer costs',
    salesNetTotal: 'Sales net total',

    buy: 'Purchase',
    rcPurchase: 'RC Purchase',
    purchaseSurchargePercent: 'Purchase surcharge %',
    purchaseDiscountPercent: 'Purchase discount %',
    purchaseNet: 'Purchase net',
    purchaseTechnicalCost: 'Purchase technical cost',
    purchaseBeerTax: 'Purchase beer tax',
    purchasePrintingCosts: 'Purchase printing costs',
    purchaseOperatingFee: 'Purchase operating fee',
    purchaseBlockSurcharge: 'Purchase block surcharge',
    purchaseTransferCosts: 'Purchase transfer costs',

    purchaseNetTotal: 'Purchase net total',

    media: 'Media',
    numberOfMedia: 'Number of media',
    technologyDictionary: 'Technology (dictionary)',
    regionDictionary: 'Region (dictionary)',
    additionalDescription: 'Additional description',

    format: 'Format',
    formatRadio: 'Format (Radio)',
    formatPress: 'Format (Press)',
    formatInternet: 'Format (Internet)',

    category: 'Category',
    categoryInternet: 'Category (Internet)',
    categoryLabcon: 'Category (Labcon)',

    purchaseForm: 'Purchase form',
    purchaseFormInternet: 'Purchase form (Internet)',
    purchaseMethod: 'Purchase method (TV)',

    emissionType: 'Broadcast type',
    emissionTypeRadio: 'Broadcast type (Radio)',
    emissionTypeCinema: 'Broadcast type (Cinema)',

    service: 'Service',
    action: 'Action',
    actionGroup: 'Action group',
    serviceExternalWorkPercent: 'External work %',
    serviceCreationPercent: 'Creation %',
    serviceChangeProductionPercent: 'Change production %',
    serviceStrategyPercent: 'Strategy %',
    serviceProductionBroadcastPercent: 'Broadcast production %',
    serviceClientServicePercent: 'Client service %',

    additionalInformation: 'Other',
    isUpSell: 'Is upsell',
    netCustomerAccount: 'Net customer account',
    copySize: 'Copy length',
    orderNumber: 'Order number',
    medium: 'Medium (Foreign)',
    ownName: 'Own name',
    labconChannel: 'Labcon channel',

    // email configurations
    mailConfig: 'Email configuration',
    mailConfigAdd: 'Adding a new configuration',
    mailConfigNew: 'New configuration',
    mailConfigEdit: 'Editing configuration no. sys.',
    noMailConfigs: 'No email configurations in the system.',
    type: 'Type',
    emails: 'Email addresses',
    mailConfigType: 'Configuration type',

    // task configurations
    jobConfig: 'Cyclic task configuration',
    jobConfigAdd: 'Adding a new configuration',
    jobConfigNew: 'New configuration',
    jobConfigEdit: 'Editing configuration no. sys.',
    noJobConfigs: 'No task configurations in the system.',
    jobConfigType: 'Configuration type',
    cron: 'Frequency',
    cronDescription: 'Description of frequency',
    nextStart: 'Next start',
    jobConfigSynchronize: 'Synchronize all tasks',
    cronError: 'Error occurred while generating frequency:',

    // bank accounts
    bankAccounts: 'Bank accounts',
    bankAccountNew: 'New bank account',
    bankAccountAdd: 'Adding a new bank account',
    bankAccountEdit: 'Editing bank account',
    noBankAccounts: 'No bank accounts in the system.',
    bankName: 'Bank name',
    accountNumber: 'Bank account number',
    swift: 'Swift BIC',
    swiftLong: 'Swift Bank Identity Code',
    invoiceType: 'Invoice type',
    VATAccountNumber: 'VAT - Bank account number',
    VATBankName: 'VAT - Bank name',

    //calendar
    calendarWorkingDay: 'Working days calendar',
    createYear: 'Create year',
    askAdd: 'Are you sure you want to add the day',
    askDelete: 'Are you sure you want to delete the day',
    to: 'to the working days calendar?',
    from: 'from the working days calendar?',
    addCalendar: 'Adding a working day',
    deleteCalendar: 'Deleting a working day',
    askAddYear: 'Are you sure you want to create the year',
    askDeleteYear: 'Are you sure you want to delete the year',
    inSystem: 'in the system?',
    warning:
      'Warning, if the year is already created, it will be deleted and recreated.',

    //dictionaries
    dictionaries: 'System dictionaries',
    dictionarySelectedDelete: 'Deleting the selected value',
    dictionarySelectedEdit: 'Editing the selected value',
    dictionarySelectedAdd: 'Adding an item under the selected value',
    dictionaryDelete: 'Deleting from the dictionary',
    dictionaryAskDelete: 'Are you sure you want to delete the value:',
    dictionaryEdit: 'Dictionary edit',
    dictionaryAdd: 'Adding value to dictionary',
    value: 'Value',
    valueEN: 'Value in English',
    symbol: 'Symbol',

    errorAttachments: 'Error while fetching attachments.',

    //upoważnieni
    authorizedNew: 'New authorized',
    authorizedEdit: 'Editing authorized no. sys.',
    authorizedAdd: 'Adding a new authorized',
    noAuthorized: 'No authorized in the system',

    //system parameters
    parameters: 'System parameters',
    group: 'Group',
    editable: 'Editable',
    noParameters: 'No parameters in the system',
    parameterEdit: 'Edit parameter',
  },
  tooltips: {
    tooltips: 'Tooltips',
    tooltipEdit: 'Edit tooltip',
    tooltipKey: 'Key',
    tooltipDescription: 'Field description (where used)',
    tooltipPlText: 'PL text',
    tooltipEnText: 'EN text',
    noTooltips: 'No tooltips in the system',
  },
  umpImport: {
    positionNameUmp: 'Position name (UMP)',
    positionNamePok: 'Position name (POK)',
    positionType: 'Position type (POK)',
    purchaseSameAsSales: 'Purchase price = Sales price',
    purchaserUmp: 'Purchaser (UMP)',
    purchaserPok: 'Purchaser (POK)',
    totalNetBudget: 'Total net budget',
    noPositions: 'No positions to display',
    umpImport: 'Import from UMP',
    umpImportDetails: 'Import from UMP (profile:',

    umpImportSuccess: 'Import completed successfully.',
    umpImportResult:
      'Imported {{ok}} of {{total}} positions (errors: {{error}})',
    umpImportSummary: 'Import summary',
    unknownPurchaser: 'PURCHASER NOT FOUND!',
    chooseParam: 'Choose parameter',
    changeParam: 'Change parameter',
  },
  recommendedPublisher: {
    recommendedPublishers: 'Recommended publishers',
    recommendedPublisherNew: 'New recommendation',
    noRecommendedPublishers: 'No recommended publishers in the system.',
    purchaser: 'Purchaser',
    publisherCount: 'Number of publishers',
    availablePublishers: 'Available publishers',
    scope: 'Scope',
    editRecommendations: 'Edit recommended publishers list',
    publisherName: 'Publisher name',
    inherited: 'Inherited',
    inherited2: 'Inherited',
    noAvailablePublishers: 'No available publishers for this profile',
    summary: 'Total',
    instruction: 'Recommendations are ADDITIVE:',
    instructionPurchaser: 'For purchaser: ',
    instructionPurchaserDetails: 'Global for profile + Company + Purchaser',
    instructionCompany: 'For company: ',
    instructionCompanyDetails: 'Global for profile + Company',
    instructionGlobal: 'General: ',
    instructionGlobalDetails: 'Only global for profile',
    clickToSelectDeselect: '(Click to select/deselect)',
    recommendedPublishersFileName: 'Recommended_publishers',
    exportFullList: 'Export full list of recommended publishers',
  },
  survey: {
    surveys: 'Surveys',
    myDraftSurveys: 'My drafts',
    mySurveys: 'My',
    activeSurveys: 'Active',
    surveyNew: 'New survey',
    surveyAdd: 'Adding a new survey',
    surveyEdit: 'Editing survey',
    noSurveys: 'No surveys in the system',
    frequency: 'Frequency',
    contractorType: 'Contractor type',
    validityPeriodDays: 'Validity period (days)',
    validityPeriodDaysTooltip:
      'Number of days for which the survey is valid from the moment it is sent. After this period expires, the survey becomes invalid.',
    remind: 'After validity period, send a reminder',
    remindShort: 'Remind',
    responsiblePersons: 'Responsible persons',
    startDate: 'Start date',
    startDateTooltip:
      'The start date indicates when the survey is sent to clients. If the date is in the future, the survey has not yet been launched. After reaching this date, the survey is launched and cannot be edited (except for changing the end date or deactivating the survey).',
    endDate: 'End date',
    question: 'Question',
    questionEn: 'Question in English',
    questions: 'Questions',
    noQuestions: 'No questions',
    responseType: 'Response type',
    optional: 'Optional',
    requiredShort: 'Required',
    answer: 'Answer',
    expectedYesNoAnswer: 'Expected Yes/No answer',
    warningLight: 'Warning light',
    unwrittenUppercase: 'UNSAVED',
    saveAndContinue: 'Save and continue',
    confirmStartSurveyMessage:
      'The start date indicates that the survey should already be in effect. Therefore, after saving, further editing of the survey will not be possible. Are you sure you want to continue?',
    confirmEndSurveyMessage:
      'The end date indicates that the survey should already be in effect. Therefore, after saving, further editing of the survey will not be possible. Are you sure you want to continue?',
    surveyWillBeSentFromDate:
      'The survey will be sent to clients from {{date}}. If it is not ready yet, remove the start date of the survey.',
    questionAdd: 'Add question',
    questionEdit: 'Edit question',
    blockOnWrongAnswer:
      'Block survey continuation if the expected answer is not provided',
    blockOnWrongAnswerShort: 'Continuation block',
    expectedAnswer: 'Expected answer',
    preview: 'SurveyPreview',
    moveQuestionUp: 'Move question up',
    moveQuestionDown: 'Move question down',
    questionDelete: 'Delete question',
    questionDeleteConfirm: 'Are you sure you want to delete this question?',
    duplicateQuestion: 'The survey contains duplicate questions',
    surveyLocked: 'Survey locked - launched',
    surveyLockedInfo:
      'Survey cannot be edited after launch date. Only the end date can be changed.',
    surveyActive: 'Active',
    surveyEnded: 'Ended',
    surveyScheduled: 'Scheduled',
    survey: 'Survey',
    emailTo: 'Recipient email',
    sendError: 'Error sending email',
    badAnswer: 'Incorrect answer',
    warningLightShort: 'Warning',
    problem: 'Answer different than expected',
    answerYesNo: 'Yes/No answer',
    answerText: 'Text answer',
    surveyEn: 'Survey in English',
    emailData: 'Email data',
    emailSubject: 'Email subject',
    emailTemplate: 'Email template',
    emailSubjectEn: 'Email subject in English',
    emailTemplateEn: 'Email template in English',
    emailTemplatePlaceholdersDesc:
      'Enter the following placeholders in the email content — they will be automatically replaced with the appropriate values.',
    emailTemplatePlaceholdersNote:
      'Note: The template must contain all required placeholders, i.e., {{required}}, the rest is optional.',
    emailTemplatePlaceholderUrl: 'survey link',
    emailTemplatePlaceholderClickToCopy: 'Click to copy',
    surveyResults: 'Survey results report',
    surveyResultsFile: 'SurveyResults',
    surveyResultsWithRemarksFile: 'SurveyResultsWithRemarks',
    surveyRequired: 'Select a survey',
    emailTemplatePlaceholderResponsible:
      'names and surnames of the responsible persons',
    emailTemplatePlaceholderCompany: 'company name e.g. Value Media',
    emailTemplatePlaceholderCompanyLong:
      'full company name e.g. Value Media Sp. z o.o.',
    nameForClientsTooltip: 'Survey name visible to the client',
    contractorTypeTooltip1:
      'Suppliers or Purchasers - surveys will be sent to contractors with at least one linked position or purchaser from the companies indicated in the survey.',
    contractorTypeTooltip2:
      'All - surveys will be sent to all contractors and all companies indicated in the survey, regardless of whether there is a purchaser or a position linked to the contractor in a given company.',
    contractorTypeTooltip3:
      'Client groups - after selecting the appropriate client group, surveys will be sent to all contractors in the selected group and all companies indicated in the survey, regardless of whether there is a purchaser or a position linked to the contractor in a given company.',
    emailTemplatePreview: 'Email template preview',
    polishVersion: 'Polish version',
    englishVersion: 'English version',
    subject: 'Subject',
    emailBody: 'Email body',
    contactType: 'Contact type',
    sendToGeneral:
      'Send to General contact if no contact of selected type exists',
    clientGroup: 'Client group',
  },
  clientSurvey: {
    clientSurveys: 'Client surveys without results',
    preparedDate: 'Prepared Date',
    sentDate: 'Sent Date',
    answeredDate: 'Answered Date',
    repetition: 'Reminder number',
    noClientSurveys: 'No client surveys in the system',
    waitingToSend: 'Waiting for send',
    waitingForAnswer: 'Waiting for answer',
    all: 'All',
    expiredWithoutReminder: 'Expired without reminder',
    repeat: 'Retry',
    repeatConfirmation:
      'Are you sure you want to re-prepare sending the survey to the client?',
    repeatSuccess: 'The client survey has been prepared.',
    repeatError: 'Failed to re-create the client survey.',
    withAnswered: 'Survey results',
    nextStartGenerateClientSurvey: 'Next start of generating client surveys',
    nextStartSendToClientSurvey: 'Next start of sending surveys to clients',
    frequency: 'Frequency',
    warning: 'Alert',
    withRemarks: 'Results with remarks',
    surveyResultsReport: 'Results report',
    surveyResultsWithRemarksReport: 'Results report with remarks',
  },
  publicSurvey: {
    invalidLink: 'Invalid survey link',
    notFoundOrInactive: 'Survey not found or inactive',
    saveError: 'An error occurred while saving the answers',
    requiredField: 'Please answer this question',
    blockedAnswer: 'This answer does not allow survey continuation',
    surveyFor: 'Survey for: ',
    estimatedTime: 'Estimated completion time',
    startSurvey: 'Start survey',
    numberOfQuestions: 'Number of questions',
    thankYou: 'Thank you!',
    answersSaved:
      'Your answers have been saved. Thank you for your time and participation in the survey.',
    surveyCompletedBy: 'Survey completed by',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    finish: 'Finish survey',
    finishSurvey: 'Finish survey',
    question: 'Question {{current}} of {{total}}',
    commentOptional: 'Comment (optional)',
    addComment: 'Add your comment...',
    errorTitle: 'Error',
    enterYourAnswer: 'Enter your answer',
    submitError:
      'An error occurred while submitting the survey. Please try again.',
  },
} as const;
